import { render, staticRenderFns } from "./publicWelfare_2.vue?vue&type=template&id=94331c7e"
import script from "./publicWelfare_2.vue?vue&type=script&lang=js"
export * from "./publicWelfare_2.vue?vue&type=script&lang=js"
import style0 from "./publicWelfare_2.vue?vue&type=style&index=0&id=94331c7e&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports